/**
 * Checks if name length is too big (useful for long names cases)
 * @param {string} input
 * @param {number} maxLength
 * @return {boolean}
 */
export function maxNameLength(input: string, maxLength: number): boolean {
  return input.length >= maxLength ? true : false;
}
